module.exports = __webpack_public_path__ + "img/25a90a8055d05d56b272fca4aa798a36.png";